import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function ArrowRight(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M6.05165 23.5484C5.44945 22.9462 5.44945 21.9698 6.05165 21.3677L15.2412 12.1781L6.05165 2.98835C5.44945 2.38627 5.44945 1.40979 6.05165 0.807713C6.65384 0.205473 7.63017 0.205473 8.23229 0.807713L18.5123 11.0877C19.1145 11.6899 19.1145 12.6662 18.5123 13.2684L8.23229 23.5484C7.63011 24.1505 6.65376 24.1505 6.05165 23.5484V23.5484Z"
  }));
}

export { ArrowRight };
//# sourceMappingURL=ArrowRight.js.map